import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GridCellRenderer } from '@softapps/core/grid';
import { MainGroup } from './main-group';

@Component({
  selector: 'soft-main-group-column',
  imports: [],
  template: `
    <div class="flex flex-col">
      <span class="soft-overline !mb-0">{{ value()?.arthauptgrp }}</span>
      <span class="text-sm">{{ value()?.bezeichnung }}</span>
    </div>`,
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainGroupColumnComponent<TRow extends object> extends GridCellRenderer<TRow, MainGroup>{

}
